import {
  trackCtaClicked,
  CtaType,
} from '@zola-helpers/client/dist/es/tracking/ctaEvents/ctaEvents';
import type { CtaEventDataType } from '@zola-helpers/client/dist/es/tracking/ctaEvents/ctaEvents';
import { BUSINESS_UNIT } from '@zola-helpers/client/dist/es/tracking/onboard/onboardTrackingConstants';

import _pick from 'lodash/pick';

import { TrackingProductLocation } from '~/util/trackingHelper';

/* ensure we only send approved fields to Segment */
const pickCTAData = (cta: unknown): Partial<CtaEventDataType> =>
  _pick(cta, ['cta_type', 'group_id', 'cta_id', 'position', 'location', 'section', 'cta']);

/* sets some defaults & merges arg */
const getCTA = (cta: Record<string, unknown> = {}): CtaEventDataType => {
  const ctaData: CtaEventDataType = {
    cta: '/inspiration/onboard',
    location: TrackingProductLocation.EXPLORE_VENDORS_PLP,
    cta_id: '',
    cta_type: CtaType.BUTTON,
    position: 1,
    section: '',
    business_unit: BUSINESS_UNIT.MARKETPLACE,
  };
  return { ...ctaData, ...cta };
};

export const trackExploreVendorsCTA = (cta: Record<string, unknown>): void => {
  const ctaEventData = getCTA(pickCTAData(cta));
  ctaEventData.cta_id ||= cta.label as string;
  trackCtaClicked({
    ...ctaEventData,
  });
};
